'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
const useSearch = (values, initialValue, value, toLabel, toValue) => {
  const $ = _c(16);
  let t0;
  if ($[0] !== toLabel || $[1] !== toValue) {
    t0 = value_0 => ({
      label: toLabel(value_0),
      value: toValue(value_0)
    });
    $[0] = toLabel;
    $[1] = toValue;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const makeOption = t0;
  let t1;
  if ($[3] !== makeOption || $[4] !== values) {
    t1 = values.map(makeOption);
    $[3] = makeOption;
    $[4] = values;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const options = t1;
  let t2;
  if ($[6] !== makeOption || $[7] !== value) {
    t2 = value ? makeOption(value) : undefined;
    $[6] = makeOption;
    $[7] = value;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const selectedOption = t2;
  let t3;
  if ($[9] !== initialValue || $[10] !== makeOption) {
    t3 = initialValue ? makeOption(initialValue) : undefined;
    $[9] = initialValue;
    $[10] = makeOption;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const initialOption = t3;
  let t4;
  if ($[12] !== initialOption || $[13] !== options || $[14] !== selectedOption) {
    t4 = {
      options,
      selectedOption,
      initialOption
    };
    $[12] = initialOption;
    $[13] = options;
    $[14] = selectedOption;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default useSearch;